import { render, staticRenderFns } from "./ReturnAcceptPopup.vue?vue&type=template&id=8afd9d18&"
import script from "./ReturnAcceptPopup.vue?vue&type=script&lang=ts&"
export * from "./ReturnAcceptPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports